// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"dd6295d9","516":"e496d8bf","580":"0c8dff8d"}[chunkId] + ".chunk.css";
};